import { Bus, Compass, Ticket, User } from "lucide-react";
import type { JSX } from "react";
import { NavLink, Route, Routes } from "react-router-dom";

import { AccountMenu } from "../common/membership/AccountMenu.js";
import { FeedPage } from "../customer/pages/FeedPage.js";
import { OfferPage } from "../customer/offer/OfferPage.js";
import { MyBookingsPage } from "../customer/pages/MyBookingsPage.js";
import { ProfilePage } from "../customer/pages/ProfilePage.js";
import { TripSearchPage } from "../customer/trips/TripSearchPage.js";

const TABS = [
  { to: "/", label: "Entdecken", Icon: Compass },
  { to: "/fahrten", label: "Fahrten", Icon: Bus },
  { to: "/tickets", label: "Tickets", Icon: Ticket },
  { to: "/profil", label: "Profil", Icon: User },
];

/**
 * Die Kunden-Shell: Inhalt mit unterer Tab-Leiste.
 *
 * Die Leiste bleibt sichtbar und zieht sich den Systemrand selbst ab — eine Polsterung
 * am body hülfe ihr nicht, weil sie fest positioniert ist und sich weiter unter die
 * Gestenleiste schöbe.
 */
export function CustomerShell(): JSX.Element {
  return (
    <div className="role-customer flex min-h-full flex-col bg-paper">
      <header className="sticky top-0 z-20 flex items-center gap-3 border-b border-line bg-surface px-4 pb-2 pt-safe-top">
        <span className="flex items-center gap-2 pt-2">
          <span
            className="grid h-8 w-8 place-items-center rounded-sm text-[11px] font-extrabold text-white"
            style={{ background: "linear-gradient(145deg, var(--brand), var(--accent))" }}
            aria-hidden="true"
          >
            BK
          </span>
          <span className="text-[15px] font-extrabold tracking-[-0.025em] text-ink">BookKing</span>
        </span>
        <span className="flex-1" />
        <span className="pt-2">
          <AccountMenu />
        </span>
      </header>

      <main className="flex-1 pb-[76px]">
        <Routes>
          <Route path="/" element={<FeedPage />} />
          <Route path="/angebot/:id" element={<OfferPage />} />
          <Route path="/fahrten" element={<TripSearchPage />} />
          <Route path="/tickets" element={<MyBookingsPage />} />
          <Route path="/profil" element={<ProfilePage />} />
          <Route path="*" element={<FeedPage />} />
        </Routes>
      </main>

      <nav
        className="fixed inset-x-0 bottom-0 z-10 border-t border-line bg-surface pb-safe-bottom"
        aria-label="Hauptbereiche"
      >
        <ul className="mx-auto flex max-w-3xl">
          {TABS.map(({ to, label, Icon }) => (
            <li key={to} className="flex-1">
              <NavLink
                to={to}
                end={to === "/"}
                className={({ isActive }) =>
                  [
                    // 44 px Mindesthöhe für Touch-Ziele (StyleGuide 6).
                    "flex min-h-[56px] flex-col items-center justify-center gap-1 text-[10.5px] font-extrabold uppercase tracking-[0.07em]",
                    isActive ? "text-role" : "text-ink-3",
                  ].join(" ")
                }
              >
                <Icon size={21} aria-hidden="true" />
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
